export let serverUrl ="";

if(window.location.hostname === "localhost"){
    serverUrl= "https://dpe.dev.tdd.rl-conseils.net";
//    serverUrl= "http://localhost:8080";
}
;//
